import { Badge, styled } from '@mui/material';

export const StyledBadge = styled(Badge)({
  'position': 'absolute',
  'top': '50%',
  'right': 0,

  '& .MuiBadge-badge': {
    top: 0,
    right: 24,
  },
});
